import Component from './component';

Component.defaultProps = {
    children: null,
};

export default Component;